import { siteInfo, navItems } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg font-bold">
                <i className="ri-movie-2-fill"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              琪琪影院致力于打造最全电影大全，最新电影、热门电影、科幻电影、动作电影高清蓝光免费在线看，海量片库每日更新。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">电影分类</h3>
            <ul className="space-y-2.5">
              <li><a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">科幻电影</a></li>
              <li><a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">动作电影</a></li>
              <li><a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">悬疑电影</a></li>
              <li><a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">喜剧电影</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h3>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-background-500">更多伙伴即将入驻</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500 text-center sm:text-left">
            &copy; 2019-2026 {siteInfo.name} 版权所有 | 电影大全 · 最新电影 · 热门电影 · 科幻电影 · 动作电影
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}